import { orgActivitiesCount, orgActPackListFun } from '../../../../api/orgActAPI';
import errorHandle from '../../../../utils/errorHandle';

export const FetchActList = async (setTripData, selectedStatus, limit, offset, setLoading) => {
    setLoading(true);
    try {
        const res = await orgActPackListFun(selectedStatus, limit, offset);
        setTripData(res.data);
    } catch (error) {
        errorHandle(error);
    } finally {
        setLoading(false);
    }
};

export const countOfActivities = async (setTotalCount, selectedStatus, setLoading) => {
    setLoading(true);
    try {
        const res = await orgActivitiesCount(selectedStatus);
        setTotalCount(res.data.packCount);
    } catch (error) {
        errorHandle(error);
    } finally {
        setLoading(false);
    }
};
